export default {"src":"/_next/static/media/0x695fd30af473f2960e81dc9ba7cb67679d35edb7.025ff5e1.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};